class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.secondaryLinks = document.querySelectorAll('.mega-menu__link--level-2');
    this.megamenuImages = document.querySelectorAll('.mega-menu__content-images');
    // this.mainDetailsToggle from parent
    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));

    // handle secondary and tertiary links
    for (const link of this.secondaryLinks) {
      link.addEventListener('mouseenter', this.onLinkMouseEnter.bind(this));
      link.addEventListener('mouseleave', this.onLinkMouseLeave.bind(this));
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }

  onMouseEnter(e) {
    clearTimeout(this.closeTimeout);
    this.mainDetailsToggle.setAttribute('open', ''); // Open the menu on hover
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true); // Update aria-expanded for accessibility
  }

  onMouseLeave(e) {
    const target = e.target;

    // Start a timer to close after a delay
    this.closeTimeout = setTimeout(() => {
      if (!this.mainDetailsToggle.matches(':hover')) {
        this.close(target);
      }
    }, 300); // 300ms delay
  }

  onLinkMouseEnter(e) {
    this.handleActiveLink(e);
    const index = e.target.dataset['secondaryLinkIndex'];
    const content = e.target.closest('.mega-menu__content');
    if (content) {
      const allContentLinks = content.querySelectorAll('.mega-menu__link--level-3');
      this.hideTertiaryLinks(allContentLinks);
    }
    if (index) {
      const tertiaryLinks = this.getTertiaryLinks(index);
      this.showTertiaryLinks(tertiaryLinks);
      const images = this.getImages(index);
      this.hideImages();
      this.showImages(images);
    }
  }

  handleActiveLink(e) {
    this.secondaryLinks.forEach((link) => {
      link.classList.remove('active');
    });
    e.target.classList.add('active');
  }

  onLinkMouseLeave(e) {}

  getTertiaryLinks(index) {
    return document.querySelectorAll(`[data-tertiary-link-index="${index}"]`);
  }

  getImages(index) {
    return document.querySelectorAll(`[data-link-image-index="${index}"]`);
  }

  showTertiaryLinks(links) {
    links.forEach((link) => {
      link.style.display = 'block';
    });
  }

  hideTertiaryLinks(links) {
    links.forEach((link) => {
      link.style.display = 'none';
    });
  }

  resetTertiaryLinks(el) {
    if (!el) return;
    const secondaryLinks = el.querySelectorAll('.mega-menu__link--level-2');
    if (!secondaryLinks) return;
    const firstLink = secondaryLinks[0];
    if (firstLink) {
      const index = firstLink.dataset['secondaryLinkIndex'];
      const tertiaryLinks = this.getTertiaryLinks(index);
      this.showTertiaryLinks(tertiaryLinks);
    }
  }

  showImages(els) {
    els.forEach((el) => {
      el.style.display = 'flex';
    });
  }

  hideImages() {
    this.megamenuImages.forEach((el) => {
      el.style.display = 'none';
    });
  }

  close(el) {
    this.mainDetailsToggle.style.opacity = '1';
    this.mainDetailsToggle.style.transition = 'opacity 0.3s ease-out';

    setTimeout(() => {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      this.mainDetailsToggle.style.opacity = '';
      this.resetTertiaryLinks(el);
    }, 300); // Match transition time
  }
}

customElements.define('header-menu', HeaderMenu);
